import sunset_image from "../images/sunset.png"; 
import morning_image from "../images/morning.png"; 
import dailysky_image from "../images/dailysky.png"; 
import { useState } from "react";
import { useDispatch } from "react-redux";
import { setBookCover } from "../reducks/orders/operations";
import { FormPageButton } from "../components/FormPageButton";

export const SelectBookCover = () => {
    const dispatch = useDispatch();

    const [selectBookCover, setSelectBookCover] = useState("sunset");
    const [bookCoverImg, setBookCoverImg] = useState(sunset_image);

    const handleSelectBookCover = (event) => {
        setSelectBookCover(event.target.value);
        if (event.target.value === "sunset") {
            setBookCoverImg(sunset_image)
        }else if(event.target.value === "morning") {
            setBookCoverImg(morning_image)
        }else {
            setBookCoverImg(dailysky_image)
        }
    }

    return (
        <div className='flex flex-col min-h-screen'>
                <main className="flex-grow">
                    <div className="pl-4 lg:pl-16 text-xl lg:text-2xl iPad/iPadMini:w-full lg:w-9/12 font-serif border-b border-black" style={{letterSpacing: '5px'}}>本の表紙デザインを選択</div>
                    <div className="grid justify-items-center pt-16 pb-16">
                        <img src={bookCoverImg} alt="book cover design" className="iPad/iPadMini:w-1/2 lg:w-1/4 h-auto border-black border"/>
                        <p className="pt-10 iPad/iPadMini:w-1/2 iPad/iPadMini:text-center w-1/4">表紙のデザインを選択</p>
                        <p className="pt-1 pb-10 iPad/iPadMini:w-1/2 w-1/4">
                            <select className="w-full border border-black shadow-sm" defaultValue={selectBookCover} onChange={handleSelectBookCover}>
                                <option value="sunset">Sunset</option>
                                <option value="morning">Morning</option>
                                <option value="dailysky">DailySky</option>
                            </select>
                        </p>
                        <FormPageButton text="次へ進む" onClick={() => dispatch(setBookCover(selectBookCover)) }/>
                    </div>
                </main>
        </div>
    )
}